<template>
  <Modal :title="title" class="clone-schedule-template-form medium" @submit="submit">
    <template v-slot:body>
      <div class="position-relative form-group col-12">
        <label class="col-12 p-0 font-weight-bold">Name*</label>
        <input class="form-control" placeholder="Name" type="text" v-model="data.name" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 p-0 font-weight-bold">Template*</label>
        <Select class="mt-2" source="schedule-template/search-shared" v-model="data.id"></Select>
      </div>

      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0 font-weight-bold">Account name*</label>
        <Select class="mt-2" source="sale-account/search" v-model="data.account_id"></Select>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      data: {
        id: '',
        name: '',
        account_id: ''
      }
    }
  },
  computed: {
    title() {
      return 'Clone Schedule'
    },
    action() {
      return 'clone'
    },
    storeId() {
      return this.config?.storeId
    },
    submitUri() {
      return 'schedule-template/clone'
    }
  },
  created() {
    this.data = {}
  },
  methods: {
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeTerm(value) {
      this.store.commit('term_id', value)
    },
    changeShared(e) {
      this.store.commit('shared', Number(e.target.checked))
    },
    setUpData(rawData) {
      let modal = `${_.pascalCase(rawData.data.platform || '')}.Schedule.ScheduleTemplate.${_.pascalCase(this.action)}`
      if (rawData.status == 'success' && this.$options.components[modal] != undefined) {
        this.showModal = true
        this.store.commit('', rawData.data)
        this.modal = modal
      } else {
        this.$emit('close')
        this.$util.notify({
          text: 'Platforms not supported!',
          status: 'error'
        })
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: (response) => {
          if (!_.isUndefined(response.id)) {
            this.$emit('close')
            this.$emitter.emit('Modal', {
              name: 'schedule-template.edit',
              data: {
                _id: response.id
              }
            })
          } else {
            this.$util.notify({
              text: 'Can not clone schedule-template!',
              status: 'error'
            })
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
#modal-container {
  .clone-schedule-template-form {
    .modal-content {
      overflow: visible;
    }
    .modal-body {
      overflow: visible;
    }
  }
}
</style>
